import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReferenceReportContentComponent} from "./reference-report-content.component";
import { FormsModule } from "@angular/forms";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { UnusualActivityComponent } from './components/unusual-activity/unusual-activity.component';
import { ReferenceCoverageComponent } from './components/reference-coverage/reference-coverage.component';
import { CandidateDetailsComponent } from './components/candidate-details/candidate-details.component';
import { CandidateResponsesComponent } from './components/candidate-responses/candidate-responses.component';
import { CoreCompetenciesComponent } from './components/core-competencies/core-competencies.component';
import { CompetencyComponent } from './components/competency/competency.component';
import { RefereeOptComponent } from './components/referee-opt/referee-opt.component';
import { AttachmentsComponent } from './components/attachments/attachments.component';
import { MatrixResponseComponent } from './components/matrix-response/matrix-response.component';
import { RefereeResponsesComponent } from './components/referee-responses/referee-responses.component';
import { ShareReportModalComponent } from './components/share-report-modal/share-report-modal.component';
import { ReplaceReferenceModalComponent } from './components/replace-reference-modal/replace-reference-modal.component';
import { LearnMoreUaModalComponent } from './components/learn-more-ua-modal/learn-more-ua-modal.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { EditResolutionModalComponent } from './components/edit-resolution-modal/edit-resolution-modal.component';
import { TimeagoModule } from 'ngx-timeago';
import { ExportSettingsModalComponent } from './components/export-settings-modal/export-settings-modal.component';
import {RefereeFileUploadComponent} from "./components/referee-file-upload/referee-file-upload.component";
import {LoaderModule} from "../../components/loader/loader.module";
import { ExportRefereeSettingsModalComponent } from './components/export-referee-settings-modal/export-referee-settings-modal.component';
import { TooltipEllipsifyModule } from 'src/app/directives/tooltip-ellipsify/tooltip-ellipsify.module';
import {
  AiReferenceSummaryModule,
  AttachmentsModule,
  BannerModule,
  CoreCompetenciesModule,
  DropdownModule,
  InputsModule,
  CheckboxModule,
  UserDetailsModule, 
  UserResponsesFeedbackModule
} from "@xref/xref-lib";
import {ModificationsModule, UnusualActivityModule} from "@xref/xref-lib";
import {ModalHeaderFeatureModule, OptInOutModule, SentimentModule} from "@xref/xref-lib";
import {CoverageModule, ButtonModule} from "@xref/xref-lib";
@NgModule({
  declarations: [
    ReferenceReportContentComponent,
    UnusualActivityComponent,
    ReferenceCoverageComponent,
    CandidateDetailsComponent,
    CandidateResponsesComponent,
    CoreCompetenciesComponent,
    CompetencyComponent,
    RefereeOptComponent,
    AttachmentsComponent,
    MatrixResponseComponent,
    RefereeResponsesComponent,
    RefereeFileUploadComponent,
    ShareReportModalComponent,
    ReplaceReferenceModalComponent,
    LearnMoreUaModalComponent,
    EditResolutionModalComponent,
    ExportSettingsModalComponent,
    ExportRefereeSettingsModalComponent,
  ],
  imports: [
    AiReferenceSummaryModule,
    CommonModule,
    FormsModule,
    TooltipModule,
    TimeagoModule.forRoot(),
    BsDropdownModule.forRoot(),
    LoaderModule,
    BannerModule,
    InputsModule,
    CheckboxModule,
    DropdownModule,
    TooltipEllipsifyModule,
    CoverageModule,
    SentimentModule,
    CoreCompetenciesModule,
    ButtonModule,
    TooltipEllipsifyModule,
    ModalHeaderFeatureModule,
    ModificationsModule,
    OptInOutModule,
    UnusualActivityModule,
    UserDetailsModule,
    AttachmentsModule,
    UserResponsesFeedbackModule
  ],
  exports: [
    ReferenceReportContentComponent
  ]
})
export class ReferenceReportContentModule { }
